import { HimuraInject } from 'himura';
import { DataDelegate } from '../data.delegate';
import * as T_T from 'cryface';
import { CommonConfig } from '../../../configs/config.common';
import { Models } from '../../../models/models';
import { AxiosPromise } from '../../../utils/axios.promise';

@HimuraInject.NamedService('WechatDelegate')
export class WechatDelegate extends DataDelegate {

    public commonConfig = new CommonConfig();

    constructor() {
        super('WechatDelegate');
    }

    public async getConfig(shareUrl: string) {
        const apihost = this.commonConfig.cmisapiHost;
        const body = {
            url: shareUrl
        };
        const fetched = await AxiosPromise.postJson(`${apihost}/wechat/signature`, body);
        // alert(JSON.stringify(fetched));
        if (fetched.status === 200) {
            const wrapped = fetched.data;
            // alert(JSON.stringify(wrapped));
            if (wrapped.code === 200) {
                return {
                    appId: wrapped.data.appId,
                    timestamp: wrapped.data.timestamp,
                    nonceStr: wrapped.data.noncestr,
                    signature: wrapped.data.signature,
                    jsApiList: ['onMenuShareAppMessage', 'onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone']
                };
            } else {
                return undefined;
            }
        } else {
            return undefined;
        }
    }

    public async generateOptions(shareUrl: string) {
        const config = await this.getConfig(shareUrl);
        if (T_T.simpleDetect(config)) {
            const options = {
                config: config,
                actions: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone']
            };
            return options;
        }
        return undefined;
    }

    /**
     *
     * @param wx
     * @param shareConfig
     */
    public share(wx: any, shareConfig: Models.IWechatShareConfig) {
        this.shareAppMsgConfig(wx, shareConfig);
        this.shareTimeLine(wx, shareConfig);
        this.shareToQQ(wx, shareConfig);
        this.shareToQZone(wx, shareConfig);
        this.shareToWeibo(wx, shareConfig);
    }

    /**
     *
     * @param wx
     * @param shareConfig
     */
    public shareAppMsgConfig(wx: any, shareConfig: Models.IWechatShareConfig) {
        wx.onMenuShareAppMessage(shareConfig);
        return;
    }

    /**
     *
     * @param wx
     * @param shareConfig
     */
    public shareTimeLine(wx: any, shareConfig: Models.IWechatShareConfig) {
        wx.onMenuShareTimeline(shareConfig);
        return;
    }

    /**
     *
     * @param wx
     * @param shareConfig
     */
    public shareToQQ(wx: any, shareConfig: Models.IWechatShareConfig) {
        wx.onMenuShareQQ(shareConfig);
        return;
    }

    /**
     *
     * @param wx
     * @param shareConfig
     */
    public shareToWeibo(wx: any, shareConfig: Models.IWechatShareConfig) {
        wx.onMenuShareWeibo(shareConfig);
        return;
    }

    /**
     *
     * @param wx
     * @param shareConfig
     */
    public shareToQZone(wx: any, shareConfig: Models.IWechatShareConfig) {
        wx.onMenuShareQZone(shareConfig);
        return;
    }

    public async ReadyPromise(wx: any): Promise<any> {
        return new Promise((resolve, reject) => {
            wx.ready(() => {
                resolve(1);
            });
            wx.error((e: any) => {
                reject(e);
            });
        });
    }

    public isWeChat() {
        return /micromessenger/.test(navigator.userAgent.toLowerCase());
    }

    public isWechatIos() {
        return /iPhone|iPad|iPod/i.test(navigator.userAgent.toLowerCase());
    }

    public wechatDecode(str: string) {
        str = str.replace('from=singlemessage', '');
        if (str.endsWith('?')) {
            str = str.replace('?', '');
        }
        if (str.endsWith('/')) {
            str = str.slice(0, str.length - 1);
        }
        if (str.endsWith('&')) {
            str = str.slice(0, str.length - 1);
        }
        return str;
    }
}
